import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import img1 from "../../Assets/requestDemo1.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function RequestDemo({ showRequestDemo, setShowRequestDemo }) {
  const formRef = useRef(null);
  const [validated, setValidated] = useState(false);
  const [details, setDetails] = useState({
    name: "",
    phone: "",
    email: "",
    jobTitle: "",
    companySize: "",
    country: "",
    companyName: "",
    message: "",
  });

  const handleSubmit = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setShowRequestDemo(false);
      setIsExiting(false);
    }, 200);
  };

  const handleChangePhone = (e) => {
    setDetails({ ...details, phone: e });
  };
  return (
    <div>
      <Modal
        size="xl"
        show={showRequestDemo}
        onHide={handleClose}
        centered
        dialogClassName={
          isExiting
            ? "aaa reqDemo custom-modal-exit"
            : "aaa reqDemo custom-modal"
        }
      >
        <Modal.Body>
          <div className="row m-0">
            <div className="col-lg-4 ps-0">
              <div className="text-end req-left-img">
                <img src={img1} alt="requestDemoFidus" />
              </div>
            </div>
            <div className="col-lg-8 ps-0 pe-0">
              <div className="reqDemo-right">
                <div className="reqDemo-right-inner">
                  <div className="font-cardo contact-us-heading">
                    Request a Demo{" "}
                  </div>
                  <div className="font-inter text-start contactUs-subHead">
                    Reach out and we’ll get in touch within 24 hours.
                  </div>
                  <div className="mt-4 contact-us-form  font-inter">
                    <form
                      ref={formRef}
                      className={`row g-3 needs-validation ${
                        validated ? "was-validated" : ""
                      }`}
                      novalidate
                      onSubmit={handleSubmit}
                    >
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom01" class="form-label">
                          Name*
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          placeholder="Enter your full name"
                          required
                        />
                        <div class="valid-feedback">Looks good!</div>
                      </div>
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom03" class="form-label">
                          Phone Number*
                        </label>
                        <PhoneInput
                          country={"in"}
                          value={details.phone}
                          onChange={handleChangePhone}
                          inputProps={{
                            name: "phone",
                            required: true,
                            autoFocus: true,
                          }}
                          placeholder="Enter you phone number"
                        />
                        <div class="invalid-feedback">
                          Please provide a valid city.
                        </div>
                      </div>
                      <div class="col col-12 col-md-12 col-lg-12">
                        <label for="validationCustom02" class="form-label">
                          Email*
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          id="validationCustom02"
                          placeholder="Enter your Email"
                          required
                        />
                        <div class="valid-feedback">Looks good!</div>
                      </div>
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom01" class="form-label">
                          Job Title*
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          placeholder="Enter your job title"
                          required
                        />
                        <div class="valid-feedback">Looks good!</div>
                      </div>
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom03" class="form-label">
                          Company Size (No. of employees)
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom03"
                          placeholder="Enter you Company Size"
                          required
                        />
                      </div>
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom01" class="form-label">
                          Country
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          placeholder="Enter your country"
                          required
                        />
                        <div class="valid-feedback">Looks good!</div>
                      </div>
                      <div class="col col-12 col-md-6 col-lg-6">
                        <label for="validationCustom03" class="form-label">
                          Company Name*
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom03"
                          placeholder="Enter you Company Name"
                          required
                        />
                      </div>

                      <div class="col col-12 col-md-12 col-lg-12">
                        <label for="validationCustom03" class="form-label">
                          Message
                        </label>
                        <textarea
                          class="form-control"
                          id="validationCustom03"
                          placeholder="Leave a message..."
                          rows={2}
                        />
                      </div>
                      <div class="col-12">
                        <button
                          class="contact-us-submit-btn  reqDemo-submit-btn"
                          type="submit"
                        >
                          Send Message
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RequestDemo;
